import React from 'react';
import { motion } from 'framer-motion';
import { allReviews } from './data/reviews';
import ReviewCarousel from './components/ReviewCarousel';
import ManifestationBanner from './components/ManifestationBanner';
import './App.css';

function App() {
  return (
    <div
      className="relative flex flex-col w-full"
      style={{
        background: 'radial-gradient(circle at 50% 40%, #4A0E0E 0%, #1a0505 50%, #100303 100%)',
        minHeight: '100dvh',
      }}
    >
      {/* Desktop: lock to 820px */}
      <style>{`
        @media (min-width: 768px) {
          .app-shell {
            height: 820px;
            max-height: 820px;
            overflow: hidden;
          }
        }
      `}</style>

      {/* Ambient glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(circle at 50% 50%, rgba(212,175,55,0.05) 0%, transparent 65%)', zIndex: 0 }}
      />

      <div className="app-shell relative flex flex-col w-full">
        <main className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-between pt-8 md:pt-12 pb-4 h-full">

          {/* ── Header ── */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center shrink-0 mb-4"
          >
            <p className="font-lexend text-gold/60 text-[9px] md:text-[10px] tracking-[0.3em] uppercase mb-3">
              130+ Years of Combined Critical Experience
            </p>
            <h1 className="font-michroma text-2xl sm:text-3xl md:text-5xl text-gold mb-2 tracking-wide drop-shadow-lg">
              CRITICAL RECEPTION
            </h1>
            <p className="font-lexend text-cream/60 text-[9px] md:text-sm tracking-widest uppercase mb-4">
              A Friendship Pod Affair &nbsp;·&nbsp; Renée Mollan-Masters
            </p>
            <div className="w-16 md:w-20 h-px bg-gradient-to-r from-transparent via-gold to-transparent mx-auto opacity-60" />
          </motion.div>

          {/* ── Unified Carousel ── */}
          <div className="flex-grow flex items-center justify-center min-h-0 py-2">
            <ReviewCarousel reviews={allReviews} />
          </div>

          {/* ── Manifestation Banner ── */}
          <div className="shrink-0">
            <ManifestationBanner />
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;